// extracted by mini-css-extract-plugin
module.exports = {"header":"blogHeader-module--header--_3GI9","blogSubtitle":"blogHeader-module--blogSubtitle--2UbAz","posts":"blogHeader-module--posts--2mmJx"};